import { Capacitor } from "@capacitor/core";

// Shared analytics vocabulary for the auth flows so event names + property values stay consistent
// across every login method (OTP, password, Google, Apple). Pass the results into useAnalytics().

export const AUTH_EVENT = {
	LOGIN_SUCCESS: "login_success",
	LOGIN_FAILED: "login_failed",
	OTP_VERIFICATION_SUCCESS: "otp_verification_success",
	OTP_VERIFICATION_FAILURE: "otp_verification_failure",
	PASSWORD_RESET_COMPLETED: "password_reset_completed",
} as const;

export const AUTH_METHOD = {
	OTP: "OTP",
	PASSWORD: "password",
	GOOGLE: "Google",
	APPLE: "Apple",
} as const;

export type AuthMethod = (typeof AUTH_METHOD)[keyof typeof AUTH_METHOD];

/** Platform the app is running on: "ios" | "android" | "web". */
export const getPlatform = (): string => Capacitor.getPlatform();

/**
 * Standard properties for auth events: which method, which platform, and whether access succeeded.
 * `access` mirrors the success/failure of the event for easy filtering in Mixpanel.
 */
export const authEventProps = (authMethod: AuthMethod, success: boolean): Record<string, string> => ({
	auth_method: authMethod,
	platform: getPlatform(),
	access: success ? "success" : "failure",
});
